import { Component, OnInit, AfterViewChecked } from '@angular/core';
import { RightSideDrawerService } from '../right-side-drawer.service';
import {
  FormGroup,
  FormControl,
} from '@angular/forms';

@Component({
  selector: 'expense-submit-history',
  templateUrl: './expense-submit-history.component.html',
  styleUrls: ['./expense-submit-history.component.scss']
})
export class ExpenseSubmitHistoryComponent implements OnInit {
  targetForm: FormGroup;
  reasons: any = [];
  constructor(
    public rightSideDrawerService: RightSideDrawerService,
  ) { }
  ngOnInit(): void {
    this.reasons = this.rightSideDrawerService.multipleRowAddData;
  }
  closeDrawer = () => {
    this.rightSideDrawerService.closeRightSideDrawer();
  }
}
